import { render, staticRenderFns } from "./ColorPage.vue?vue&type=template&id=21fcb791"
import script from "./ColorPage.vue?vue&type=script&lang=js"
export * from "./ColorPage.vue?vue&type=script&lang=js"
import style0 from "./ColorPage.vue?vue&type=style&index=0&id=21fcb791&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports